export const INCENTIVE_IMG_DEFAULT: string = 'assets/img/incentive-trophy.png'
